import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { useStore } from "../../../stores/StoreContext";

import "./Footer.scss";

const RawFooterComponent = () => {
  const { t } = useTranslation();
  const { navigationStore } = useStore();

  return (
    <div className="footer">
      <div className="links">
        {navigationStore.externalNavigationLinks
          ?.filter(link => link.url?.length)
          .map(link => (
            <div key={link.labelKey}>
              <a href={link.url} className="link" target="_blank">
                {t(link.labelKey)}
              </a>
            </div>
          ))}
      </div>
    </div>
  );
};

export const FooterComponent = observer(RawFooterComponent);
